export const translationKeys = {
  freeSpins: 'Free Spins',
  multiplier: 'Multiplier',
  yes: 'Yes',
  no: 'No',
  buy: 'BUY',
  dragonSpins: 'DRAGON SPINS',
  multiplierBeginsAt: 'MULTIPLIER BEGINS AT',
  buyBonus: 'BUY BONUS',
  congratulations: 'CONGRATULATIONS',
  youHaveWon: "YOU HAVE WON",
  pressToContinue: 'PRESS TO CONTINUE',
  autoSpin: 'AUTOSPIN',
  play: 'PLAY',
  balance: 'BALANCE',
  lastWin: 'LAST WIN',
  betAmount: 'BET AMOUNT',
  spinCount: 'Spin Count',
  history: 'History',
  info: 'Info',
  deposit: 'Deposit',
  INVALID_TOKEN: 'INVALID TOKEN ',
  INVALID_SPIN: 'INVALID SPIN',
  MONEY_TRANSACTION_ERROR: 'MONEY TRANSACTION ERROR ',
  NOT_ENOUGH_MONEY: 'NOT ENOUGH MONEY ',
  INVALID_OPERATION: 'INVALID OPERATION',
  SPIN_NOTFOUND: 'SPIN NOT FOUND ',
  INVALID_SPIN_COUNT: 'INVALID SPIN COUNT ',
  INVALID_AMOUNT: 'INVALID AMOUNT ',
};

export const TKeys = {
  GameInfo: 'GAME_INFO',
  Time: 'TIME',
  Bet: 'BET',
  WinOdd: 'WIN_ODD',
  Win: 'WIN',
  Bonus: 'BONUS',
}

export const defaultTranslation = {
  GAME_INFO: `
        <p><strong>Main Game Logic</strong></p>
        <p>To participate in the game user must place his bet and press the spin button, from the left and right sides of the swing he will be offered 4 types of rock balls (total quantity in the game - 17), any of which has a fixed range of odds. After pressing a spin button the ball located in the center (in the dragon's mouth) will be crashed or cracked. The crashed ball also can consist</p>
        <p>If the ball is crashed user's bet will be multiplied by the odd which will occur from the crashed ball.</p>
        <p>If the ball is cracked user's bet will be considered as lost.</p>
        <p><em>NOTE</em></p>
        <p><em>Users will have an opportunity to skip the rock balls anytime if they don’t want to crash it, using the skip button (the feature is free of charge)</em></p>
        <p>The crashed ball also can consist of an opportunity to enter the bonus game, instead of odd.</p>
        <p>The user will see the pop-up noticing that he has been granted the bonus game.</p>
        <p>The main game RTP is 97,9%</p>
        <p><strong>Bonus Game</strong></p>
        <p>Users can buy bonus game tickets or can be rewarded randomly during the spin. If the user want to buy the bonus game he needs to press the bonus game button which will show the price for it depending on the bet amount (bonus game feature price = bet amount x 100).</p>
        <p>By pressing the "BUY BONUS" button user will be offered 3 types of tickets</p>
        <p>Ticket 1 - 10 spins multiplier begins at x1</p>
        <p>Ticket 1 - 5 spins multiplier begins at x3</p>
        <p>Ticket 1 - 3 spins multiplier begins at x5</p>
        <p>By choosing the desired ticket user will be offered to confirm the purchase from the pop-up.</p>
        <p>user can confirm the purchase by pressing "checkmark icon"</p>
        <p>user can cancel the purchase by pressing the "X" icon</p>
        <p><em>If the user confirms the purchase he will be moved to the bonus game</em></p>
        <p>During the bonus game a special animated character - a dragon, will be activated. Al the rock balls on the scene will go back to caves and new ones will be provided on the swing, the total quantity of the balls in the bonus game is 9, 4 from each side and 1 in the middle in dragons month.</p>
        <p>During every spin, the dragon will crush all the rock balls on the scene, all 9. Some of the rock balls will be cracked, which means they stay for the next spin without providing any odd, crushed rock balls will provide odds which will be multiplied together and by the bet amount, after all the main win will be multiplied by the ticket's default multiplier and the end amount will be the win amount for the current spin.</p>
        <p>From the left side of the scene, the user will be able to see the free bet count, which will be decreased after every spin, from the right side is a multiplier, which can be increased during the bonus game if some of the crushed balls will consist multiplier.</p>`,
  [TKeys.Time]: 'Time',
  [TKeys.Bet]: 'Bet',
  [TKeys.WinOdd]: 'Win Odd',
  [TKeys.Win]: 'Win',
  [TKeys.Bonus]: 'Bonus',
};
